import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFileExport, faFilter, faGear, faLink, faList } from "@fortawesome/free-solid-svg-icons";
import { Box, Stack, Typography } from "@mui/material";
import { isUndefinedorEmpty } from "../transformer/UnregisteredFunctions";

const colors = [
  { backgroundColor: "#acc4f8", color: "#165bf1" },
  { backgroundColor: "#d3f4ae", color: "#7ed321" },
  { backgroundColor: "#fae1ac", color: "#ffad00" },
  { backgroundColor: "#ffddde", color: "#ff6d73" },
];

const steps = [
  {label:"Choose Connection",icon: <FontAwesomeIcon icon={faLink} /> },
  {label:"Configure Connection",icon: <FontAwesomeIcon icon={faGear} />},
  {label:"Filter Filename",icon: <FontAwesomeIcon icon={faFilter} /> },
  {label:"Update Mapping",icon: <FontAwesomeIcon icon={faList} />},
  {label:"Export Exception Files",icon: <FontAwesomeIcon icon={faFileExport} />},
  {label:"Review Summary",icon: <FontAwesomeIcon icon={faCheck} />},
];


export default function IntegrationToolStepper(props:{
    index:number,
    setState:(idx:number)=>void,
    stepperMapping?:(string|null)[]
}) {
  return (
    <div className="integration-stepper-wrapper">
      {steps.map((s, idx) => (
        <Stack
          className="integration-stepper-steps"
          key={idx}
          onClick={() => props.setState(Math.min(idx, props.index))}
          sx={{
            backgroundColor: props.index === idx ? "#eee !important" : "#fff",
          }}
        >
          <Box className={"stepper-icon"} sx={{ ...colors[idx % 4] }}>
            {s.icon}
          </Box>
          <Box width={"100%"}>
            <Typography className={"stepper-label-text"} variant="subtitle1">
              {props.stepperMapping && !isUndefinedorEmpty(props.stepperMapping[idx]) ? props.stepperMapping[idx]: s.label}
            </Typography>
          </Box>
        </Stack>
      ))}
    </div>
  );
}

